<template>
  <FormKit
    :type="type"
    :name="name"
    :label="title"
    :value="value"
    :disabled="disabled"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'InputCapacity',
  props: ['type', 'value', 'name', 'title', 'disabled']
})
export default class InputComponent extends Vue {}
</script>

<style lang="scss">
.formkit-outer {
  font-family: 'Ubuntu-Regular';
  height: 48px;
  margin-bottom: 30px;
  .formkit-wrapper {
    position: relative;
    .formkit-inner {
      max-width: 377px;
      box-shadow: none;
      border: 1px solid $border;
      border-radius: 8px;
      input {
        font-family: 'Ubuntu-Regular';
      }
      .formkit-input {
        border-radius: 8px;
        height: 48px;
        font-size: 14px;
        box-sizing: border-box;
        color: $main-text;
        &:disabled {
          background: $white;
        }
      }
    }
    .formkit-label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      z-index: 1;
    }
  }
}

.formkit-messages {
  font-size: 13px;
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px $white inset !important;
}
</style>
